import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgArrowLeftIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M30.955 17.633H17.98a3.614 3.614 0 0 0-.4-.483 4.005 4.005 0 0 0-.467-.392l3.7-3.7c.2-.2.2-.525 0-.725L18.63 10.15c-.2-.2-.525-.2-.725 0L8.72 19.333c-.2.2-.2.525 0 .725l9.184 9.184c.2.2.525.2.725 0l2.183-2.184c.2-.2.2-.525 0-.725l-3.7-3.7c.167-.116.325-.241.467-.391.15-.15.283-.317.4-.484h12.975a.52.52 0 0 0 .516-.516V18.15a.52.52 0 0 0-.516-.517Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};
export default SvgArrowLeftIcon;
